"use strict";import{tag as r}from"../custom-tag.js";export function openMailIcon({height:l=16,width:a=16,hidden:t=!1,title:e="Open mail"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${a}
      height=${l}
      fill="currentColor"
      viewBox="0 0 35 35"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <g fill="currentColor">
        <path
          d="M4.051 30.625a.33.33 0 0 0 .328.328h26.246a.33.33 0 0 0 .328-.328v-12.84h-.002l.002-.009a.33.33 0 0 0-.169-.279l-2.456-1.363V4.375A.33.33 0 0 0 28 4.047H7a.33.33 0 0 0-.328.328v11.757l-2.456 1.365a.33.33 0 0 0-.17.28c0 .005.005.01.005.017zm1.663-.328 9.871-5.149 1.74 1.083a.33.33 0 0 0 .346 0l1.742-1.084 9.873 5.15zm22.614-13.412 1.65.916-1.65 1.027zm1.969 1.49v11.709l-10.237-5.34zM7.328 4.703h20.344v14.533l-10.174 6.33-10.17-6.33zm-.656 12.18v1.945L5.022 17.8zm-1.965 1.495 10.231 6.368-10.23 5.336z"
        />
        <path
          d="M25.375 8.422H9.625v.656h15.75zm0 3.5H9.625v.656h15.75zm0 3.5H9.625v.656h15.75z"
        />
      </g>
    </svg>
  `}
//# sourceMappingURL=openMail.js.map
